import React, { Component } from 'react'
// import { withRouter } from 'react-router-dom'
import { Col, message, Modal, Row } from 'antd'
import { graphql, withApollo } from '@apollo/client/react/hoc'
import { flowRight as compose } from 'lodash'

import CustomerSearchResult from './CustomerSearchResult'
// import CreateCustomerModal from './../../components/ui/dataEntry/other/CreateCustomerModal'
import ButtonContainer from '../../components/ui/general/buttons/ButtonContainer'
import AddButton from '../../components/ui/general/buttons/AddButton'
import { utilityService } from '../../services/UtilityService'
import MutationCreateCustomer from '../../graphQL/customers/createCustomer'
import HistoryList from '../auditManager/HistoryList'
import Input from '../../components/ui/dataEntry/inputs/Input'
import mutationCreateVenueUser from 'graphQL/venue/createVenueUser'
import userMessages from 'constants/messages'

class CustomerSidebar extends Component {
  constructor (props) {
    super(props)
    this.state = {
      searchString: 'optusvenue',
      isCreateCustomerVisible: false,
      isCreateVenuePopUpOpen: false,
      isModalLoading: false,
      isSearchHistoryVisible: false,
      isVenueNameSaving: false,
      venueUserName: ''
    }
  }

  UNSAFE_componentWillMount (newProps) { // eslint-disable-line camelcase
    // if (this.props.match && this.props.match.params && this.props.match.params.id) {
    //   this.setState({ searchString: this.props.match.params.id })
    // }
  }

  onSearchCustomer = searchString => {
    this.setState({ searchString, isSearchHistoryVisible: false })
  }

  onCreateCustomer = data => {
    this.setState({ isModalLoading: true })
    this.props.createCustomer(data).then(
      () => {
        this.setState({ isCreateCustomerVisible: false, isModalLoading: false })
        message.success('Customer created successfully')
      },
      error => {
        this.setState({ isModalLoading: false })
        utilityService.handleError(error)
      }
    )
  }

  onCloseCustomerCreate = () => {
    this.setState({
      isCreateCustomerVisible: false
    })
  }

  toggleSearchHistory = () => {
    const { isSearchHistoryVisible } = this.state
    this.setState({ isSearchHistoryVisible: !isSearchHistoryVisible })
  }

  handleVenuePopup = flag => this.setState({ isCreateVenuePopUpOpen: flag })
  handleSubmitCreateVenuePopUp = async () => {
    const { venueUserName } = this.state
    this.setState({ isVenueNameSaving: true })
    const { createVenueUser } = this.props
    try {
      const createVenueUserDetails = await createVenueUser({ venueName: venueUserName })
      if (createVenueUserDetails?.data?.createVenueUser?.success) {
        this.setState({
          isVenueNameSaving: false,
          isCreateVenuePopUpOpen: false,
          venueUserName: ''
        })
        message.success(userMessages.CREATE_VENUE_USER_SUCCESS_MESSAGE)
      }
    } catch (err) {
      this.setState({
        isVenueNameSaving: false
      })
      utilityService.handleError(err)
    }
  }

  render () {
    const { venueUserName, isVenueNameSaving } = this.state
    const { onSelectCustomer, selectedCustomer, project, refetchCustomerList } = this.props
    const {
      searchString,
      isCreateVenuePopUpOpen,
      // isModalLoading,
      isSearchHistoryVisible
    } = this.state
    return (
      <div className='customer-sidebar'>
        <CustomerSearchResult
          searchString={searchString}
          onSearchCustomer={this.onSearchCustomer}
          selectedCustomer={selectedCustomer}
          onSelectCustomer={onSelectCustomer}
          onHandleBack={this.showSearchOptions}
          project={project}
          isChanging={refetchCustomerList}
        />
        {isSearchHistoryVisible ? (
          <HistoryList
            showFilter={false}
            content='VENUE_MANAGER'
            contentId={'CSM'}
            project={project}
            refetchCSMHistoryList={() => {}}
            seachField={this.onSearchCustomer}
          />
        ) : (
          ''
        )}
        <div className='customer-list-footer' id={'customer-list-footer'}>
          <span className='search-history' onClick={this.toggleSearchHistory}>
            {isSearchHistoryVisible ? 'Hide recent searches' : 'Show recent searches'}
          </span>
          {project === 'hyperion' || project === 'projectx' ? (
            ''
          ) : (
            <ButtonContainer
              displayTitle='Create Venue'
              childComponent={<AddButton onClick={() => this.handleVenuePopup(true)} />}
            />
          )}
          {/* <CreateCustomerModal
            isVisible={isCreateVenuePopUpOpen}
            handleSubmit={this.onCreateCustomer}
            handleCancel={this.onCloseCustomerCreate}
            isSubmitDisabled={isModalLoading}
            isLoading={isModalLoading}
          /> */}

          <Modal
            title='CREATE VENUE'
            visible={isCreateVenuePopUpOpen}
            onOk={this.handleSubmitCreateVenuePopUp}
            onCancel={() => {
              this.handleVenuePopup(false)
              this.setState({ venueUserName: '' })
            }}
            confirmLoading={isVenueNameSaving}
            okButtonProps={{
              disabled: !venueUserName
            }}
            className='general-modal'
            okText='Save'
          >
            <Row>
              <Col span={24}>
                <Input
                  title='Venue Name'
                  placeholder='Enter Venue Name'
                  inputName='title'
                  isRequired
                  value={venueUserName}
                  handleChange={(e) => {
                    const { value } = e.target
                    this.setState({
                      venueUserName: value
                    })
                  }}
                  isLimited
                  limit={30}
                  // onFocus={onInputFieldFocus}
                  // isError={isInvalidTitle}
                  // errorMessage={userMessages.EMPTY_TITLE}
                  // onBlur={onInputFieldBlur}
                />
              </Col>
            </Row>
          </Modal>
        </div>
      </div>
    )
  }
}

// export default withRouter(CustomerSidebar)
export default withApollo(
  compose(
    graphql(MutationCreateCustomer, {
      props: props => ({
        createCustomer: variables => {
          return props.mutate({
            variables
          })
        }
      })
    }),
    graphql(mutationCreateVenueUser, {
      props: props => ({
        createVenueUser: variables => {
          return props.mutate({
            variables
          })
        }
      })
    })
  )(CustomerSidebar)
)
